import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";

export const TodoForm = (props) => {
    const [name, setName] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        props.addTask(name);
        setName('');
    }

    const handleChange = (e) => {
        setName(e.target.value);
    }

    return (
        <Form className="todo-form" onSubmit={handleSubmit}>
            <Form.Group>
                <InputGroup className="mb-7">
                    <Form.Control
                        type="text"
                        id="new-todo-input"
                        name="text"
                        autoComplete="off"
                        value={name}
                        onChange={handleChange}
                        placeholder="Search by Account, Package, Email or Phone"
                    />
                    <InputGroup.Append>
                        <Button variant="primary" type="submit">&#128270;</Button>
                    </InputGroup.Append>
                </InputGroup>
            </Form.Group>
        </Form>
    );
}
